import * as React from "react";
import { Select } from "antd";
import { ForwardSelect } from "./ForwardSelect";
import {
  VehicleType,
  displayStringForVehicleType
} from "../lib/model/VehicleType";

type Props = {
  value?: VehicleType;
  onSelect: (value: VehicleType) => void;
};

const Option = Select.Option;

export class VehicleSelect extends React.Component<Props> {
  render() {
    const { value } = this.props;
    return (
      <ForwardSelect
        label="* Fahrzeugtyp"
        onSelect={this.handleSelect}
        value={value}
      >
        {Object.values(VehicleType).map((v, i) => (
          <Option key={`${i}`} value={v}>
            {displayStringForVehicleType(v)}
          </Option>
        ))}
      </ForwardSelect>
    );
  }
  handleSelect = (index: number, option: React.ReactElement<any>) => {
    const selected = option.props.value as VehicleType;
    this.props.onSelect(selected);
  };
}
